module.exports = __webpack_public_path__ + "static/media/eit.5e1defcd.webp";